import { ContractRole } from 'app/types/types'
import { t } from 'i18next'

// Static role identifiers for runtime translation
export const CONTRACT_ROLE_KEYS = {
  DECIDED_BY: 'review.partyRoles.decidedBy',
  SOLD_TO: 'review.partyRoles.soldTo',
  BILLED_TO: 'review.partyRoles.billedTo',
  PAYER: 'review.partyRoles.payer',
  COVER_LETTER: 'review.partyRoles.coverLetter'
} as const

// Factory function to create default contract roles with translations at runtime
export const getDefaultContractRoles = (): ContractRole[] => [
  { role: t(CONTRACT_ROLE_KEYS.DECIDED_BY), type: 'account', accountNumber: '' },
  { role: t(CONTRACT_ROLE_KEYS.SOLD_TO), type: 'account', accountNumber: '' },
  { role: t(CONTRACT_ROLE_KEYS.BILLED_TO), type: 'account', accountNumber: '' },
  { role: t(CONTRACT_ROLE_KEYS.PAYER), type: 'account', accountNumber: '' },
  { role: t(CONTRACT_ROLE_KEYS.COVER_LETTER), type: 'account', accountNumber: '' }
]

// Maintain backward compatibility with the original export
export const defaultContractRoles: ContractRole[] = [
  { role: 'decidedBy', type: 'account', accountNumber: '' },
  { role: 'soldTo', type: 'account', accountNumber: '' },
  { role: 'billedTo', type: 'account', accountNumber: '' },
  { role: 'payer', type: 'account', accountNumber: '' },
  { role: 'coverLetter', type: 'account', accountNumber: '' }
]

export const getDefaultContractRolesWithPartner = (): ContractRole[] => [
  { role: CONTRACT_ROLE_KEYS.DECIDED_BY, type: 'account', accountNumber: '' },
  { role: CONTRACT_ROLE_KEYS.SOLD_TO, type: 'partner', accountNumber: '' },
  { role: CONTRACT_ROLE_KEYS.BILLED_TO, type: 'partner', accountNumber: '' },
  { role: CONTRACT_ROLE_KEYS.PAYER, type: 'partner', accountNumber: '' },
  { role: CONTRACT_ROLE_KEYS.COVER_LETTER, type: 'partner', accountNumber: '' }
]

// Maintain backward compatibility with the original export
export const defaultContractRolesWithPartner: ContractRole[] = [
  { role: 'decidedBy', type: 'account', accountNumber: '' },
  { role: 'soldTo', type: 'partner', accountNumber: '' },
  { role: 'billedTo', type: 'partner', accountNumber: '' },
  { role: 'payer', type: 'partner', accountNumber: '' },
  { role: 'coverLetter', type: 'partner', accountNumber: '' }
]
